export const GET_MEETING_MINUTES_CATEGORIES = 'GET_MEETING_MINUTES_CATEGORIES'
export const GET_MEETING_MINUTES = 'GET_MEETING_MINUTES'
export const GET_TASK_MEETING_MINUTES = 'GET_TASK_MEETING_MINUTES'
export const GET_TASKMAP_MEETING_MINUTES = 'GET_TASKMAP_MEETING_MINUTES'
export const ADD_BOARD_MEETING_MINUTES = 'ADD_BOARD_MEETING_MINUTES'
export const EDIT_BOARD_MEETING_MINUTES = 'EDIT_BOARD_MEETING_MINUTES'
export const DELETE_BOARD_MEETING_MINUTES = 'DELETE_BOARD_MEETING_MINUTES'
